import { buildUrl } from "../ReusableFunctions/reusableFunctions";
import { SERVER_URLS } from "../appConstants";
import { getToken } from "./authentication";
export const getAcreageGraphData = async ({
  fromDate,
  toDate,
  interval,
  pilotId,
  locationId,
  cropName,
  droneId,
}) => {
  try {
    const token = getToken();

    const url = buildUrl(
      `${SERVER_URLS.BACKEND_SERVER}/dsp/acreage/total-acreage/${encodeURIComponent(fromDate)}/${encodeURIComponent(toDate)}/${interval}`,
      {
        pilotId: pilotId ? pilotId : undefined,
        locationId: locationId ? locationId : undefined,
        cropName: cropName ? cropName : undefined,
        droneId: droneId ? droneId : undefined,
      },
    );
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    const res = await response.json();

    if (!response.ok) {
      throw new Error(res.message || "Something went wrong");
    }

    return res?.totalAcreage || [];
  } catch (err) {
    throw err;
  }
};
